import { render } from "./StepFour.vue?vue&type=template&id=d68b9062&scoped=true"
import script from "./StepFour.vue?vue&type=script&lang=js"
export * from "./StepFour.vue?vue&type=script&lang=js"

import "./StepFour.vue?vue&type=style&index=0&id=d68b9062&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d68b9062"]])

export default __exports__